//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, reduce } from 'lodash'
import { useHistory } from 'react-router-dom'
import { useRouteMatch } from 'react-router'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import Table from '../../components/Table'
import { kioskDiagnosticActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseDatePicker from '../../hooks/UseDatePicker'
import { DatePickerFilterLabel, PageWrapperLinks } from '../../theme/GlobalCss'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import urlExport from '../../constants/UrlExport'
import { uriList } from '../../routings/settings/RouteList'
import KioskDiagnosticStatus from './Components/KioskDiagnosticStatus'
import KioskDiagnosticMessage from './Components/KioskDiagnosticMessage'
import StringFormatter from '../../helpers/StringFormatter'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Calendar from '../../assets/icones/global/calendar.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerKioskDiagnosticIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
//////STYLED//////

const KioskDiagnostic = () => {
	let history = useHistory()
	const match = useRouteMatch()
	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)
	const [idKioskProduction, setIdKioskProduction] = useState(match.params.id)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'createdDate', nameDir: 'asc' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modals
	const [stepSwitch, setStepSwitch] = useState(false)

	const { user, translations, kioskDiagnostic, kioskDiagnosticFilters, userKioskPerimeter, isSearchfieldUpdated } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			kioskDiagnostic: state.kioskDiagnostic,
			kioskDiagnosticFilters: state.kioskDiagnostic.header,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
		}),
		shallowEqual
	)

	const actionsKioskDiagnostic = bindActionCreators(kioskDiagnosticActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const [
		dateKioskDiagnosticShowModal,
		dateKioskDiagnosticOpenDateModalHandler,
		dateKioskDiagnosticRenderModal,
		dateKioskDiagnosticStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate(),
	})

	// Config
	const [configTable, setConfigTable] = useState({})

	// Columns
	const [columns, setColumns] = useState([])

	/////////////////////////////// HANDLER ////////////////////////////////////////

	const handlePagingKioskDiagnostic = (paging) => {
		setPaging(paging)
		actionsKioskDiagnostic.postKioskDiagnostic(idKioskProduction, handleFilterSend(), paging)
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsKioskDiagnostic.postKioskDiagnostic(idKioskProduction, handleFilterSend(), paging)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			datesRange: {
				/* "dateStart" :		"2008-09-02T08:59:55",
				"dateEnd" : 		"2030-09-09T18:59:55"	 */

				dateStart: dateKioskDiagnosticStateDate.date.startDate,
				dateEnd: dateKioskDiagnosticStateDate.date.endDate,
			},
			searchField: filters.searchField?.length > 0 ? filters.searchField : '',
			...filtersOut,
		}
	}
	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		},
		paging: {
			fnSendTo: (paging) => handlePagingKioskDiagnostic(paging),
		},
	})
	/////////////////////////////// CONFIG //////////////////////////////////////
	useEffect(() => {
		setColumns([
			{
				columnReferential: 'seeKioskLog_status',
				dataHook: 'level.translationKey',
				headerName: translations['page__initKiosksProduction__kiosksLogShow_tableHeader_status'],
				sortable: true,
				isAuthorize: true,
				component: (props) => <KioskDiagnosticStatus level={props.row.level.id} />,
			},
			{
				columnReferential: 'seeKioskLog_dateHour',
				dataHook: 'date',
				headerName: translations['page__initKiosksProduction__kiosksLogShow_tableHeader_dateHour'],
				sortable: true,
				isAuthorize: true,
				component: (props) => moment(props.row.date).format('DD/MM/YYYY HH:mm'),
			},
			{
				columnReferential: 'seeKioskLog_event',
				dataHook: 'event',
				headerName: translations['page__initKiosksProduction__kiosksLogShow_tableHeader_event'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				columnReferential: 'seeKioskLog_message',
				dataHook: 'message',
				headerName: translations['page__initKiosksProduction__kiosksLogShow_tableHeader_message'],
				sortable: true,
				isAuthorize: true,
				component: (props) => <KioskDiagnosticMessage>{props.row.message}</KioskDiagnosticMessage>,
			},
			{
				columnReferential: 'seeKioskLog_category',
				dataHook: 'category',
				headerName: translations['page__initKiosksProduction__kiosksLogShow_tableHeader_categorie'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				columnReferential: 'seeKioskLog_subCategory',
				dataHook: 'subCategory',
				headerName: translations['page__initKiosksProduction__kiosksLogShow_tableHeader_subCategorie'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				columnReferential: 'seeKioskLog_level',
				dataHook: 'level.translationKey',
				headerName: translations['page__initKiosksProduction__kiosksLogShow_tableHeader_level'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 23,
		labelPageTable: 'seeKioskLog',
	}

	///////////////////////////////USE EFFECT//////////////////////////////////////

	useEffect(() => {
		setIdKioskProduction(match.params.id)
		return function cleanUp() {
			actionsKioskDiagnostic.resetDataKioskDiagnostic()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)

		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		setFilters(kioskDiagnosticFilters)
		setPrevFilter(kioskDiagnosticFilters)
	}, [translations, kioskDiagnosticFilters])

	useEffect(() => {
		if (dateKioskDiagnosticStateDate.showModal) {
			actionsKioskDiagnostic.postKioskDiagnostic(idKioskProduction, handleFilterSend(), paging)
		}
	}, [dateKioskDiagnosticShowModal])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks)) {
			actionsKioskDiagnostic.postKioskDiagnostic(idKioskProduction, handleFilterSend(), paging)
		}
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		const filtersCp = cloneDeep(filters) // add fot he new filters method
		let cfg = cloneDeep(configTableTitle)

		if (!isEqual(kioskDiagnostic?.pageTitleParam, {}))
			cfg.name = `${translations['page__initKiosksProduction__kiosksLogShow_title']} ${kioskDiagnostic?.pageTitleParam.owner} - ${kioskDiagnostic?.pageTitleParam.kioskCode} - ${kioskDiagnostic?.pageTitleParam.kioskName}`
		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__initKiosksProduction__kiosksLogShow_filters_date']} :
					</label>
					<DatePickerKioskDiagnosticIcon onClick={dateKioskDiagnosticOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{moment(dateKioskDiagnosticStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{moment(dateKioskDiagnosticStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]
		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__initKiosksProduction__kiosksLogShow_filters_level']}
					data={filtersCp.filtersSelection?.levels.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					submitOnClose={handleSubmit}
					selectActionsHandler={handleCheckElements}
					target={'levels'}
				/>
			),
		]
		cfg.paging = {
			totalElements: kioskDiagnostic.paging.totalElements,
			totalPages: kioskDiagnostic.paging.totalPages,
			fnSendTo: (paging) => handlePagingKioskDiagnostic(paging),
		}

		setConfigTableTitle(cfg)
	}, [translations, filters, dateKioskDiagnosticStateDate, kioskDiagnostic?.pageTitleParam])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)

		cfgCp.export = {
			privilege: userPrivileges.export[22],
			url: StringFormatter.ResponseMessageParser(urlExport[19], [match.params.id]),
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				searchField: searchValue,
				datesRange: { dateEnd: dateKioskDiagnosticStateDate.date.endDate, dateStart: dateKioskDiagnosticStateDate.date.startDate },
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		setConfigTable(cfgCp)
	}, [translations, filters, dateKioskDiagnosticStateDate, kioskDiagnostic?.pageTitleParam])

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setStepSwitch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (stepSwitch) {
			let state_date = {}

			// Default date
			state_date.startDate = moment().startOf('day').toDate()
			state_date.endDate = moment().hours(23).minutes(59).toDate()

			// And for state of datepicker
			setStartDate(moment(state_date.startDate).toDate())
			setEndDate(moment(state_date.endDate).toDate())

			const filtersCp = {
				withFilters: searchValue?.length > 0 ? true : false,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				searchField: searchValue || '',
				datesRange: {
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				filtersSelection: null,
				searchFieldUpdated: false,
			}
			actionsKioskDiagnostic.postKioskDiagnostic(idKioskProduction, filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [stepSwitch, translations])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(kioskDiagnostic) && !isUndefined(kioskDiagnostic)) {
			cfg.paging = {
				totalElements: kioskDiagnostic.paging.totalElements,
				totalPages: kioskDiagnostic.paging.totalPages,
				fnSendTo: (paging) => handlePagingKioskDiagnostic(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [kioskDiagnostic])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={kioskDiagnostic.items}
				inputConfig={configTable}
				isLoading={kioskDiagnostic.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
			/>
		)
	}, [kioskDiagnostic, columns, configTable, translations, paging])

	return (
		<Fragment>
			{dateKioskDiagnosticRenderModal()}
			<UsersManagerWrapper>
				<PageWrapperLinks>
					<Button
						goBack
						weight="bold"
						actionHandler={() => {
							history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}`)
						}}
						text={translations['common__text__previousPage']}
					/>
				</PageWrapperLinks>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

KioskDiagnostic.propTypes = {}

KioskDiagnostic.defaultPropTypes = {}

export default KioskDiagnostic
